import formatImages from './formatImages'
/* eslint-disable import/no-anonymous-default-export */
export default function(stateRoom) {
  return {
    ...stateRoom,
    stateroom: {
      ...stateRoom.stateroom,
      image: stateRoom.stateroom ? formatImages(stateRoom.stateroom.image) : []
    }
  }
}
